var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZillowReviewsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3ceff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.20956,
    stopColor: "#71a4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#006aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0040ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.92242,46.41199c-.9151-1.02887-1.3808-2.37683-1.31708-3.74646l-.24054.20032v8.16895c1.39728-.87622,3.18341-1.85321,5.18146-2.8656-1.38544-.08478-2.69244-.70996-3.62384-1.7572Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.16937,42.86584l-21.8797-18.25482-4.73071,3.93878,1.55994.31177c1.86774.37323,3.39362,1.73035,3.98224,3.54175.58862,1.81134.15192,3.80621-1.13977,5.20612l-1.83893,1.9928.23523,2.00305c3.74158-1.46301,7.18604-2.66254,9.61896-3.30261h.00214c.22162-.05804.32269.02582.45392.18073.75299.89502,3.17981,4.01459,3.84027,4.86871.09772.12268.07751.30133-.04517.39905-.00421.00336-.00854.00659-.01294.0097-4.89227,4.0296-10.33527,9.7287-13.36877,13.81213-.06451.08606-.01074.09253.03229.07312,5.28381-2.40094,17.69305-6.23267,23.29102-7.30621v-7.47406Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.16937,58.59491c-5.98303,1.07355-23.86328,6.68231-31.99127,11.10132-.15057.10327-.35498.07318-.47327-.07312l-4.08551-5.13544c-.11401-.13983-.12262-.21301.02148-.44104,3.15613-4.88586,9.59741-12.48688,13.70654-15.70752.07318-.05811.05377-.10974-.03229-.07965-4.28125,1.47589-16.44525,6.99213-20.94812,9.6814v17.44806h43.80243v-16.79401Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.33508,32.784l-4.46301-.89185-.10425-.18579h0l-2.12317-3.78333c-.48669-.86713-1.73492-.86713-2.22156,0l-2.22736,3.96912-4.46307.89185c-.9751.19489-1.36084,1.38202-.68652,2.11279l3.08655,3.34485-.53101,4.5202c-.01331.1134-.00824.22211.00629.32745.00464.03363.01404.06482.02124.09741.01569.07086.03534.13916.06226.20459.01367.03333.02838.065.04468.09674.03192.06201.06891.11975.11017.17511.01923.02582.03638.05237.05743.0766.05951.06854.12512.1308.19739.1853.00702.00531.01257.01227.01971.0174.08038.05811.16815.10468.25995.14307.02765.0116.05658.01831.08502.02795.06702.02271.13489.04065.20551.05188.03503.00555.06982.00879.10553.01135.02979.00214.05853.00958.08868.00958.04175,0,.08435-.00934.12659-.01367.03192-.00323.06311-.00452.09515-.01031.10413-.0188.20844-.04718.31165-.09467l4.13495-1.90173,4.13501,1.90173c.76514.35199,1.59918-.1239,1.76831-.87683.00018-.00006.00031-.00012.00049-.00018.00012-.00055,0-.00122.00012-.00177.03021-.13544.04584-.27661.0282-.427l-.53088-4.52014,3.08655-3.34491c.67432-.73077.28857-1.91791-.68658-2.11279Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZillowReviewsScraper);
export default __webpack_public_path__ + "static/media/zillow-reviews-scraper.c1b7a326f6cbd7e6d7da82afb3dea483.svg";
export { ForwardRef as ReactComponent };